<template>
  <div class="bg-stand" style="height: 100%">
    <top-header></top-header>
    <div class="update-body">
      <div class="toastr animated animate" v-if="close_toastr"
        :class="{ slideInRight: close_toastr, slideOutRight: !close_toastr }" style="z-index: 100000">
        <h4>
          Success
          <span class="closebtn" @click="closetoastr"> &times; </span>
        </h4>
        <p v-if="email_success">
          {{ email_success_text }}
        </p>
        <p v-if="data_success">Data updated successfully</p>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-5 update-body-nav">
          <p>
            <img src="@/assets/all-department-lllustration.svg" />
          </p>
          <h4 class="my-3">Create Page</h4>
          <p class="text-center w-75 px-4">
            Create a page for your organisation to regularly updating your
            colleagues.
          </p>
        </div>
        <div class="col-sm-12 col-md-7">
          <div class="row">
            <div class="col-sm-12 col-md-9">
              <div class="px-3 pb-2 pt-5 add-new-folder" v-if="!done_created">
                <h4>Create Page</h4>
                <p class="d-flex flex-column">
                  <input type="text" placeholder="Enter page name" class="w-75" v-model="page" @input="check" />
                  <span class="error" v-if="page_error">Please enter a company page name</span>
                  <span class="error" v-if="error">{{ page }} already exist</span>
                  <span class="good" v-if="good">{{ page }} is available</span>
                </p>
                <div class="my-4 d-flex justify-content-between flex-row">
                  <div class="d-flex flex-column">
                    <label style="font-size: 15px">Page profile image</label>
                    <input type="file" ref="pix" @change="showImageInModal" />
                  </div>
                  <div>
                    <span v-if="$store.getters.COMPANY_PHOTO" class="trigger_pic_self">
                      <img :src="$store.getters.COMPANY_PHOTO" />
                    </span>
                  </div>
                </div>
                <p class="my-3">
                  <span class="save-btn" @click="create">
                    &plus; Create Page
                  </span>
                </p>
              </div>
              <div class="
                    px-3
                    py-3
                    folder-list
                    d-flex
                    flex-column
                    justify-content-center
                  " style="height: 100%" v-if="done_created">
                <h4>Company Page</h4>
                <div>
                  <ul class="create-company-page">
                    <li class="d-block">
                      <div v-if="!edit_mode" class="d-flex justify-content-between">
                        <span class="dept-box">{{ page_name }}</span>
                        <span class="
                              action
                              d-flex
                              justify-content-center
                              align-items-center
                            ">
                          <span @click="edit_page()" style="cursor: pointer">
                            <img src="@/assets/Edit.svg" />
                          </span>
                        </span>
                      </div>
                      <div v-if="edit_mode" class="d-flex justify-content-between">
                        <span style="flex: 1">
                          <input type="text" class="edit_text" v-model="page" ref="edit" @input="check"
                            style="height: 100%; padding: 0 10px" />
                          <span class="error" v-if="page_error">Please enter a company page name</span>
                          <span class="error" v-if="error">{{ page }} already exist</span>
                          <span class="good" v-if="good">{{ page }} is available</span>
                        </span>
                        <span class="
                              action2
                              d-flex
                              justify-content-center
                              align-items-center
                            " style="margin-left: 10px">
                          <span class="cancel-btn" @click="cancel_page()" style="cursor: pointer">
                            Cancel
                          </span>
                          &nbsp;&nbsp;&nbsp;
                          <span class="save-btn2" @click="save_page()" style="cursor: pointer">
                            Save
                          </span>
                        </span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <startupload ref="startupload"></startupload>

    <div>
      <b-modal ref="image-crop-modal" id="image-crop-modal" hide-footer no-close-on-backdrop>
        <template v-slot:modal-title> Crop the image </template>
        <div class="d-block">
          <b-img :src="imageToCrop" ref="image-to-crop" fluid-grow alt="Fluid-grow image"></b-img>
        </div>
        <div class="mt-3">
          <div class="container-fluid p-1">
            <div class="row">
              <div class="col-6">
                <button @click="hideModal()" class="btn btn-secondary btn-block">
                  Cancel
                </button>
              </div>
              <div class="col-6">
                <button @click="uploadImage" class="btn btn-primary btn-upload btn-block">
                  Upload
                </button>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>

    <loading ref="loading"></loading>
    <editdepartmentload ref="editloader"></editdepartmentload>
    <notify ref="notify"></notify>
    <embeded ref="embed"></embeded>
    <invite ref="invite"></invite>
    <logout ref="logout"></logout>
  </div>
</template>
<style scoped>
.cancel-btn {
  background-color: #fff;
  border: 1px solid #3f96d1;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 103px;
  height: 46px;
  font-size: 14px;
  border-radius: 10px;
  color: #3f96d1;
}

.save-btn2 {
  background-color: #3f96d1;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 103px;
  height: 46px;
  font-size: 14px;
  border-radius: 10px;
  color: #fff;
}

.error {
  color: #fc6d6c;
}

.folder-list ul li {
  padding: 12px 0 !important;
  margin: 0 !important;
  font-size: 14px !important;
}

.folder-list ul li:hover {
  background: transparent;
}

.folder-list .folder-name {
  color: #111111;
  font-size: 14px;
}

.add-new-folder {
  font-family: "inter";
}

.folder-list {
  font-family: "inter";
}

.folder-list h4 {
  color: #000;
  font-size: 18px;
  font-weight: 600;
}

.add-new-folder h4 {
  color: #000;
  font-size: 18px;
  font-weight: 600;
}

.save-btn {
  background-color: #3f96d1;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 46px;
  font-size: 14px;
  border-radius: 10px;
  color: #fff;
}

.update-body {
  width: 92% !important;
  padding: 0 !important;
  height: 630px !important;
}

.update-body .row {
  height: 100%;
}

.update-body-nav {
  height: 100% !important;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-family: "inter";
}

.update-body-nav h4 {
  color: #000;
}

.department {
  display: flex;
  flex-direction: column;
  margin-bottom: 0.8em;
}

.department select {
  border: 1px solid #e1e1e1;
  padding: 0.8em 0.5em;
}

.assign {
  margin: 12px 0;
}

.assign label {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 13px;
}

.assign input {
  margin-right: 0.4em;
  width: auto;
}

.add-department .error {
  color: #fc6d6c;
}

.form {
  background: #f9f9f97e url("../../public/bg.png");
  height: calc(100% - 160px);
  text-align: left;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 1em;
}

.form .add-department {
  width: 30%;
}

.form .add-department h4 {
  font-weight: bold;
}

.form input[type="text"] {
  width: 100%;
  border: 1px solid #f1f1f1;
  border-radius: 3px;
  padding: 1em 1em;
}

.form .btn {
  cursor: pointer;
  background: #0071e0;
  color: #fff;
  border-radius: 3px;
  padding: 1em 1em;
  display: inline-block;
  text-align: center;
  width: 100%;
}

.top-header {
  border-bottom: 1px solid #f9f9f9;
}

.undraw {
  width: 20%;
}

.undraw img {
  max-width: 100%;
}

.bottom-pane {
  text-align: left;
}

.listed-department {
  background: #fff;
  padding: 1em;
  width: 35%;
  height: auto;
}

.listed-department li {
  display: flex;
  align-items: center;
}

.listed-department li span {
  margin-left: 0.4em;
}

.bottom-pane h1 {
  font-size: 50px;
  font-weight: bold;
  color: #000;
}

p {
  margin: 0;
}

.add-department p:first-child {
  margin-bottom: 0.6em !important;
}

.bottom-pane {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding-top: 0.9em;
}

span.create_public {
  display: block;
  margin-top: 0.5em;
}

span.create_public label input {
  display: inline !important;
  /*width: auto !important;*/
}

.add-department .error {
  color: #fc6d6c;
}

.form {
  background: #f9f9f97e url("../../public/bg.png");
  height: calc(100% - 160px);
  text-align: left;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 1em;
}

.form .add-department {
  width: 30%;
}

.form .add-department h4 {
  font-weight: bold;
}

.form input {
  width: 100%;
  border: 1px solid #f1f1f1;
  border-radius: 3px;
  padding: 1em 1em;
}

.form .btn {
  cursor: pointer;
  background: #0071e0;
  color: #fff;
  border-radius: 3px;
  padding: 1em 1em;
  display: inline-block;
  text-align: center;
  width: 100%;
}

.top-header {
  border-bottom: 1px solid #f9f9f9;
}

.undraw {
  width: 20%;
}

.undraw img {
  max-width: 100%;
}

.bottom-pane {
  text-align: left;
}

.listed-department {
  background: #fff;
  padding: 1em;
  width: 35%;
  height: auto;
}

.listed-department li {
  display: flex;
  align-items: center;
  margin-bottom: 0.9em;
}

.listed-department li span {
  margin-left: 0.4em;
}

.bottom-pane h1 {
  font-size: 50px;
  font-weight: bold;
  color: #000;
}

p {
  margin: 0;
}

.add-department p:first-child {
  margin-bottom: 0.6em !important;
}

.bottom-pane {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding-top: 0.9em;
}

.listed-department ul li .department-mode {
  display: flex !important;
  justify-content: space-between !important;
  width: 100%;
}

.listed-department ul li .department-mode .text-field {
  flex-grow: 2;
}

.listed-department ul li .department-mode .text-field input {
  width: 80%;
  padding: 0.4em 0.5em;
}

.action span {
  cursor: pointer;
}

input[name="create_folder"] {
  width: auto;
}
</style>

<script>
import loading from "@/components/Loading";
import TopHeader from "@/components/Top-Header";
import AuthenticationService from "../services/AuthenticationService";
import logout from "@/components/Logout";
import editdepartmentload from "@/components/Edit-Department-Loading";
import notify from "@/components/Notify";
import { mapMutations } from "vuex";
import cookies from "@/services/cookies";
import embeded from "@/components/Embed";
import startupload from "@/components/Upload-Company-Profile-Picture";
import invite from "@/components/Invite";
import "cropperjs/dist/cropper.css";
import Cropper from "cropperjs";

export default {
  components: {
    TopHeader,
    loading,
    editdepartmentload,
    notify,
    embeded,
    invite,
    startupload,
    logout,
  },
  data() {
    return {
      cropper: Object,
      imageToCrop: "",
      answer: "",
      error: false,
      department: "",
      departments: [],
      name: "",
      page: "",
      post: true,
      department_name_exist: false,
      create_folder: false,
      close_toastr: false,
      firstname: localStorage.getItem("firstname"),
      lastname: localStorage.getItem("lastname"),
      position: localStorage.getItem("position"),
      account_type: localStorage.getItem("account_type"),
      text: "",
      done_created: false,
      good: false,
      page_error: false,
      page_name: "",
      edit_mode: false,
    };
  },
  methods: {
    ...mapMutations([
      "SET_FILE_ACTION",
      "REMOVE_FILE_ACTION",
      "SET_DIRECTORY_CHILDREN",
      "TOGGLE_FILE_INFO",
      "SORT_DIRECTORY_CHILDREN",
      "SORT_STORED_DIRECTORY_CHILDREN",
      "SET_STORED_DIRECTORY_CHILDREN",
      "GET_DIRECTORY_CHILDREN",
      "CLOSE_FILE_INFO",
      "SET_PATH",
      "UPDATE_SLIDEIN",
      "UPDATE_SLIDEOUT",
      "UPDATE_BODY_MENU",
      "UPDATE_MENU",
      "UPDATE_TOTAL_CREATED_IMAGES",
      "UPDATE_TOTAL_CREATED_DOCUMENTS",
      "UPDATE_TOTAL_CREATED_FOLDERS",
      "SET_FIRSTNAME",
      "SET_LASTNAME",
      "SET_EMAIL",
      "SET_PHONE",
      "SET_POSITION",
      "SET_DEPARTMENT",
      "SET_COUNTRY",
      "SET_DATE_CREATED",
      "SET_ACCT_TYPE",
      "SET_ISADMIN",
      "SET_PHOTO",
      "UPDATE_TOTAL_SPACE",
      "UPDATE_DEFAULT_FOLDER",
      "UPDATE_TOTAL_USED_SPACE",
      "SET_ISTRIAL",
      "SET_ISSTAFF",
      "SET_ISSUPERADMIN",
      "SET_PATH",
      "SORT_DIRECTORY_CHILDREN",
      "SET_CURRENT_DIRECTORY",
      "SET_CURRENT_PLAN",
      "UPDATE_PUBLIC_FOLDER_ID",
      "HIDE_FILE_INFO",
      "SET_FILE_ACTION",
      "SET_SELECT_ALL",
      "SET_USER_PLAN",
      "UPDATE_USER",
      "SET_NAME",
      "SET_IS_SECURITY_QUESTION",
      "SET_PLAN_STATUS",
      "SET_TRIAL_STATUS",
      "SET_HAS_CRM",
      "SET_HAS_INVEX",
      "SET_INVEX_DOMAIN",
      "SET_INVEX_API_URL"
    ]),
    change_pic() {
      this.UPDATE_SLIDEIN(false);
      this.UPDATE_SLIDEOUT(true);
      this.UPDATE_MENU(false);
      this.UPDATE_BODY_MENU(false);

      this.$refs.pic.click();
    },
    start_upload() {
      this.$refs.startupload.load(this.$refs.pic.files[0]);
      this.$refs.pic.value = "";
    },
    slideout($evt) {
      if ($evt.target.tagName === "svg" || $evt.target.tagName === "path") {
        this.UPDATE_SLIDEIN(false);
        this.UPDATE_SLIDEOUT(true);
        this.UPDATE_MENU(false);
        this.UPDATE_BODY_MENU(false);
      } else {
        if ($evt.target.classList.contains("menubody")) {
          this.UPDATE_SLIDEIN(false);
          this.UPDATE_SLIDEOUT(true);
          this.UPDATE_MENU(false);
          this.UPDATE_BODY_MENU(false);
        }
      }
    },
    hideModal() {
      this.$refs["image-crop-modal"].hide();
    },
    done(url) {
      this.$refs["pix"].value = "";
      this.imageToCrop = url;
    },
    invite() {
      this.$refs.invite.load();
    },
    showImageInModal(e) {
      const files = e.target.files;
      if (files && files.length > 0) {
        const file = files[0];
        if (URL) {
          this.done(URL.createObjectURL(file));
        } else if (FileReader) {
          const reader = new FileReader();
          reader.onload = () => {
            this.done(reader.result);
          };
          reader.readAsDataURL(file);
        }
      }
      this.$refs["image-crop-modal"].show();
    },
    uploadImage() {
      if (this.cropper) {
        const canvas = this.cropper.getCroppedCanvas({
          width: 160,
          height: 160,
        });
        canvas.toBlob((blob) => {
          const file = new File([blob], "photo.jpeg", { type: '"image/jpeg"' });
          this.$refs.startupload.load(file, false);
          this.$refs["image-crop-modal"].hide();
        });
      }
    },
    startupload() {
      this.$refs.startupload.load(this.$refs.pix.files[0], false);
      this.$refs.pix.value = "";
    },
    check(evt) {
      if (evt.target.value !== "") {
        let that = this;
        let data = {
          name: evt.target.value,
          token: cookies.getCookie("token"),
        };

        this.$socket.emit("check-page-name", data, function (data) {
          if (data.data == false) {
            that.error = false;
            that.good = true;
          } else {
            that.error = true;
            that.good = false;
          }

          if (data.result == false) {
            that.$router.push("login");
          }
        });
      }
    },
    create() {
      if (this.error === false) {
        if (this.page !== "") {
          this.$refs.loading.load();
          this.good = false;
          this.page_error = false;
          this.error = false;
          let that = this;
          let data = {
            name: this.page,
            token: cookies.getCookie("token"),
          };

          this.$socket.emit("create-page-name", data, function (data) {
            if (data.data == true) {
              that.done_created = true;
              that.page_name = data.page_name;
              that.$refs.loading.close();
            }

            if (data.result == false) {
              that.$router.push("login");
            }
          });
        } else {
          this.page_error = true;
        }
      }
    },
    save_page() {
      if (this.error === false) {
        if (this.page !== "") {
          this.$refs.loading.load();
          let that = this;
          let data = {
            name: this.page,
            token: cookies.getCookie("token"),
          };

          this.$socket.emit("create-page-name", data, function (data) {
            if (data.data == true) {
              that.edit_mode = false;
              that.done_created = true;
              that.page_name = data.page_name;
              that.$refs.loading.close();
            }

            if (data.result == false) {
              that.$router.push("login");
            }
          });
        } else {
          this.page_error = true;
        }
      }
    },
    edit_page() {
      this.page = this.page_name;
      this.edit_mode = true;
    },
    cancel_page() {
      this.edit_mode = false;
    },
    notifyexpiration(text) {
      this.$refs.notify.load(text);
    },
    create_department() {
      if (this.$store.getters.ISTRIAL) {
        if (!this.$store.getters.TRIAL_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.notifyexpiration(
              "Your trial period has expired. Please contact your admin"
            );
            return;
          } else {
            this.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</>'
            );
            return;
          }
        }
      } else {
        if (!this.$store.getters.PLAN_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.notifyexpiration(
              "Your trial period has expired. Please contact your admin"
            );
            return;
          } else {
            this.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</>'
            );
            return;
          }
        }
      }

      if (this.department == "") {
        this.error = true;
      } else {
        this.error = false;
        this.department_name_exist = false;
        this.$refs.loading.load();

        let that = this;

        let data = {
          token: cookies.getCookie("token"),
          name: this.department,
          create_folder: this.create_folder,
        };

        AuthenticationService.create_department(data)
          .then((res) => {
            if (res.data.data === true) {
              that.department = "";
              that.$refs.loading.close();
              that.create_folder = false;

              that.departments.push({
                _id: res.data.id,
                name: res.data.name,
                edit_mode: false,
              });
            }

            if (res.data.exist === true) {
              that.$refs.loading.close();
              that.department_name_exist = true;
            }

            if (res.data.result == false) {
              that.$router.push("login");
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    close() {
      this.error.message = false;
    },
    logout() {
      this.$refs.logout.logout();
    },
    user_data() {
      let data = {
        token: cookies.getCookie("token"),
      };

      let that = this;

      this.$socket.emit("get-data", data, function (data) {
        if (data.data === true) {
          that.SET_ACCT_TYPE(data.account_type);
          that.SET_ISADMIN(data.isSuperAdmin);
          that.SET_FIRSTNAME(data.firstname);
          that.SET_LASTNAME(data.lastname);
          that.SET_NAME(data.firstname + " " + data.lastname);
          that.SET_EMAIL(data.email);
          that.SET_PHONE(data.phone);
          that.SET_POSITION(data.position);
          that.SET_DEPARTMENT(data.department);
          that.SET_COUNTRY(data.country ? data.country : "");
          that.SET_DATE_CREATED(data.date_created);
          that.SET_PHOTO(data.photo);
          that.UPDATE_TOTAL_SPACE(data.total_space);
          that.UPDATE_TOTAL_USED_SPACE(data.total_space_used);
          that.UPDATE_USER(data.id);
          that.SET_CURRENT_PLAN(data.current_plan);
          that.SET_USER_PLAN(data.user_plan);
          that.SET_PLAN_STATUS(data.isPlanActive);
          that.SET_TRIAL_STATUS(data.isTrialActive);
          that.SET_HAS_CRM(data.hasCrm);
          that.SET_HAS_INVEX(data.hasInvex);
          that.SET_INVEX_DOMAIN(data.invex_domain);
          that.SET_INVEX_API_URL(data.invex_api_url);
          that.SET_ISTRIAL(data.isTrial);
          that.SET_ISSTAFF(data.isStaff);
          that.SET_ISSUPERADMIN(data.isSuperAdmin);

          that.SET_IS_SECURITY_QUESTION(data.is_security_question);

          that.UPDATE_DEFAULT_FOLDER(data.default_folders);

          that.UPDATE_PUBLIC_FOLDER_ID(data.public_folder_id);
          localStorage.setItem("id", data.id);
          localStorage.setItem("email", data.email);
          localStorage.setItem(
            "is_security_question",
            data.is_security_question
          );
          sessionStorage.setItem("gi", data.group_folder_id);
          sessionStorage.setItem("pi", data.project_folder_id);

          that.done_created = data.page_name !== "";
          that.page_name = data.page_name;

          that.UPDATE_TOTAL_CREATED_IMAGES(data.total_created_images);
          that.UPDATE_TOTAL_CREATED_DOCUMENTS(data.total_created_documents);
          that.UPDATE_TOTAL_CREATED_FOLDERS(data.total_created_folders);
        }
      });
    },
  },
  mounted() {
    this.user_data();

    let that = this;
    if (
      cookies.getCookie("token") != "" &&
      cookies.getCookie("token") != null
    ) {
      let data = {
        token: cookies.getCookie("token"),
      };

      this.$socket.emit("url:auth", data, (data) => {
        if (data.data == false) {
          that.$router.push("/login");
        }
      });
    } else {
      this.$router.push("/login");
    }
  },
};
</script>
